import { InMemoryCache } from '@apollo/client'

export const cacheConfig = {
  addTypename: true,
  typePolicies: {
    propertiesCp: { keyFields: ['property_id', 'id'] },
    Note: { keyFields: ['note_id'] },
    Query: {
      fields: {
        allClientCases: {
          // @ts-ignore
          merge(_, incoming = []) {
            // Return the incoming array to completely replace existing data
            // This ensures we don't get cache warnings and maintains consistency
            return incoming
          },
          // Ensure proper read function to handle both array and object formats
          read(existing: unknown) {
            // If the existing data is an object with numeric keys, convert it to an array
            if (existing && !Array.isArray(existing)) {
              return Object.values(existing)
            }
            return existing
          }
        }
      }
    }
  },
}

export default new InMemoryCache(cacheConfig)
